import { MONTH_SHORT_LABELS } from '@crm/shared';
import { Select } from '@crm/ui';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSession } from '@/modules/auth/hooks';

export interface DashboardPeriod {
  year: number;
  month: number;
}

/**
 * Filtro do painel: a competencia e a unidade. Sem moldura nem fundo - a
 * barra e um controle de leitura, nao um formulario, e qualquer caixa ali
 * competiria com os numeros logo abaixo.
 */
export function DashboardFilters({
  period,
  onPeriodChange,
  unitId,
  onUnitChange,
}: {
  period: DashboardPeriod;
  onPeriodChange: (value: DashboardPeriod) => void;
  unitId: string;
  onUnitChange: (value: string) => void;
}) {
  const { user } = useSession();
  const units = user?.units ?? [];

  const andar = (passo: number) => {
    const alvo = new Date(period.year, period.month - 1 + passo, 1);

    onPeriodChange({ year: alvo.getFullYear(), month: alvo.getMonth() + 1 });
  };

  const agora = new Date();
  /** Nao ha painel do futuro: o mes seguinte ainda nao aconteceu. */
  const noMesAtual = period.year === agora.getFullYear() && period.month === agora.getMonth() + 1;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-1">
        <button
          type="button"
          aria-label="Mes anterior"
          onClick={() => andar(-1)}
          className="flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>

        <span className="min-w-24 text-center text-sm font-semibold uppercase tracking-wide">
          {MONTH_SHORT_LABELS[period.month - 1]} {period.year}
        </span>

        <button
          type="button"
          aria-label="Proximo mes"
          disabled={noMesAtual}
          onClick={() => andar(1)}
          className="flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:pointer-events-none disabled:opacity-30"
        >
          <ChevronRight className="h-5 w-5" />
        </button>
      </div>

      {/* A unidade so aparece para quem atende mais de uma - a regra vale em
          toda tela do sistema. */}
      {units.length > 1 ? (
        <Select
          aria-label="Unidade do painel"
          className="h-auto w-auto border-0 bg-transparent py-0 pl-0 pr-6 text-right text-sm font-medium text-primary shadow-none focus-visible:ring-0"
          value={unitId}
          onChange={(event) => onUnitChange(event.target.value)}
        >
          <option value="">Todas as unidades</option>
          {units.map((unit) => (
            <option key={unit.id} value={unit.id}>
              {unit.name}
            </option>
          ))}
        </Select>
      ) : null}
    </div>
  );
}
